import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../app.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { AddInductionTypesComponent } from './components/add-induction-types/add-induction-types.component';
import { DialogAddSectionComponent } from './components/dialog-add-section/dialog-add-section.component';
import { InductionSlideSelection, InductionTypes, ModalUpdateSection } from './config-setup-inductionand-sections';

@Component({
  selector: 'app-config-setup-inductionand-sections',
  templateUrl: './config-setup-inductionand-sections.component.html',
  styleUrls: ['./config-setup-inductionand-sections.component.css']
})
export class ConfigSetupInductionandSectionsComponent implements OnInit {

  constructor(
    private _inductionService:SafetyInductionService,
    private _appService:AppService,
    private _dialog: MatDialog, 
  ) { }

  categories:InductionTypes[]=[];
  questions:InductionSlideSelection[]=[];

  


  ngOnInit() {
    this._appService.setPageTitle('Setup Induction and Sections');
   // this._appService.setPageSubTitle('');
  this.GetInductionTypes()
  }


  GetInductionTypes(){
    this._inductionService.GetInductionTypes().subscribe(res=>{ 
    //console.log("InductionTypes",res)
    this.categories=res.InductionTypes;

    if(this.categories && this.categories.length >0){

      this.categories.map(c=>{
        let ques = res.Selections.filter(f=>f.InductionType == c.ID)
        c.questions = ques
      })

    }

    this.questions=res.Selections;
    })
  }

  
  
  openAddInductionTypesDialog() {
    const dialogRef = this._dialog.open(AddInductionTypesComponent, {
      panelClass: 'removeModalOverflow',
      minWidth: 300,
      data: {}
    });

    dialogRef.afterClosed().subscribe(r => {
        //this.loadImplementDetails1();
        if(r){

          this.GetInductionTypes()
        }
    });
}

EditCategory(cat){
  const dialogRef = this._dialog.open(AddInductionTypesComponent, {
    panelClass: 'removeModalOverflow',
    minWidth: 300,
    data: {
      Active:cat.Active,
      typeID:cat.ID,
      Name:cat.Title,
      Description:cat.Description,
      ExpiryMonths:cat.ExpiryMonths
    }
  });

  dialogRef.afterClosed().subscribe(r => {
      //this.loadImplementDetails1();
      if(r){
        this.GetInductionTypes()
      }
  });
}

openAddSectionDialog(cat) {
  const dialogRef = this._dialog.open(DialogAddSectionComponent, {
    //panelClass: 'removeModalOverflow',
    minWidth: 300,
    data: {
      typeid :cat.ID
    }
  });

  dialogRef.afterClosed().subscribe(r => {
      //this.loadImplementDetails1();
      if(r){
        this.GetInductionTypes()
      }
  });
}

ChangeActive(qus){
  let params = new ModalUpdateSection();

    params.selectionId = qus.ID;
    params.selectionName = qus.Title;
    params.typeid = qus.InductionType
    params.active=!qus.Active;
    params.order=qus.Order;
    

    //create new category
    this._inductionService.UpdateSection(params).subscribe(res => {
      console.log("CreateInductionSelections", res)
      if (res.m_Item1) {
        this.GetInductionTypes()
      }
      // this.dialogRef.close();

    })
}

SectionUp(CatId:number, Order:number){
this._inductionService.OrderUp_InductionCategories(CatId, Order).subscribe(res=>{
  if(res){
    this.GetInductionTypes()
  }
})
}

SectionDown(CatId:number, Order:number){
  this._inductionService.OrderDown_InductionCategories(CatId, Order).subscribe(res=>{
    if(res){
      this.GetInductionTypes()
    }
  })
}

EditSection(qus){
  const dialogRef = this._dialog.open(DialogAddSectionComponent, {
    panelClass: 'removeModalOverflow',
    minWidth: 300,
    data: {
      edit:true,
      ID:qus.ID,
      typeid :qus.InductionType,
      Name:qus.Title,
      Order:qus.Order,
      Active:qus.Active
    }
  });

  dialogRef.afterClosed().subscribe(r => {
      //this.loadImplementDetails1();
      if(r){
        this.GetInductionTypes()
      }
  });
}


}
